/* Scroll depth for the categories page.
   Two jobs: reveal blocks as they enter the viewport, and drift each product picture inside
   its own violet card so the tiles read as layers rather than as a flat grid.

   The hiding half of the reveal is gated behind the .pe-anim class that this file adds, so a
   page whose script never arrives simply shows everything. Hiding content in CSS and relying
   on JavaScript to bring it back turns any loading hiccup into a blank catalogue.

   The drift is published as the --py custom property rather than an inline transform, because
   the card design already animates the same image on hover; an inline transform would wipe
   that out. pe-atacado.css composes the two.

   Positions are measured once (and on resize / image load), never inside the scroll handler,
   so the loop only ever writes. Reading a rect that already carries our own offset would feed
   back into the next frame and make the drift creep. */
(function () {
  var DRIFT = 24;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealables = [].slice.call(document.querySelectorAll('.pe-rv'));

  if (!reduce && 'IntersectionObserver' in window && revealables.length) {
    document.documentElement.classList.add('pe-anim');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    revealables.forEach(function (el) { io.observe(el); });
  }

  if (reduce) return;

  var layers = [].slice.call(document.querySelectorAll('.pe-ct__grid .pe-cat__img')).map(function (el) {
    return { el: el, top: 0, h: 0 };
  });
  if (!layers.length) return;

  var vh = window.innerHeight;
  var queued = false;

  function measure() {
    layers.forEach(function (l) { l.el.style.removeProperty('--py'); });
    var y = window.pageYOffset;
    layers.forEach(function (l) {
      var r = l.el.getBoundingClientRect();
      l.top = r.top + y;
      l.h = r.height;
    });
    vh = window.innerHeight;
  }

  function paint() {
    queued = false;
    var y = window.pageYOffset;
    for (var i = 0; i < layers.length; i++) {
      var l = layers[i];
      var center = l.top + l.h / 2 - y;
      if (center < -l.h || center > vh + l.h) continue;
      var p = (center - vh / 2) / vh;
      if (p > 0.85) p = 0.85;
      if (p < -0.85) p = -0.85;
      l.el.style.setProperty('--py', (p * DRIFT).toFixed(1) + 'px');
    }
  }

  function onScroll() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(paint);
  }

  measure();
  paint();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { measure(); paint(); });
  window.addEventListener('load', function () { measure(); paint(); });
  setTimeout(function () { measure(); paint(); }, 1200);
})();
